import { useCallback, useState } from 'react';

import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

import { SitterProfileBHPriceToggleClickEvent } from '../analyticsEvents';

export interface UseSittersRatesToggle {
  showSittersRates: boolean;
  onToggleSittersRates: (checked: boolean) => void;
}

const useSittersRatesToggle = (
  isShowingPriceInCurrency?: boolean,
  shouldShowBhToggle?: boolean
): UseSittersRatesToggle => {
  const { user } = useCurrentUser();
  const [isToggleOn, setIsToggleOn] = useState(isShowingPriceInCurrency ?? false);

  const onToggleSittersRates = useCallback(
    (checked: boolean): void => {
      user?.isBrightHorizonsUser &&
        emitAnalyticsEvent(
          new SitterProfileBHPriceToggleClickEvent({
            personId: user.opk,
          })
        );
      setIsToggleOn(checked);
    },
    [user]
  );

  const showSittersRates = shouldShowBhToggle ? isToggleOn : true;

  return { showSittersRates, onToggleSittersRates };
};

export default useSittersRatesToggle;
